import React from 'react';

const MastercardIcon = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 32 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="10" r="10" fill="#EB001B" />
      <circle cx="21" cy="10" r="10" fill="#F79E1B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 17.5C18.7614 15.9289 20.5 12.7338 20.5 9.5C20.5 6.26619 18.7614 3.07107 16 1.5C13.2386 3.07107 11.5 6.26619 11.5 9.5C11.5 12.7338 13.2386 15.9289 16 17.5Z"
        fill="#FF5F00"
      />
    </svg>
  );
};

export default MastercardIcon; 